import { createZodErrorMap, englishValidationT } from '@dinewise/i18n';
import { z } from 'zod';

// Zod 4 JIT-compiles validators with `new Function`, which an enforcing CSP blocks
// as an unsafe-eval violation. Disable the JIT so validation stays CSP-compliant.
// Must run before any schema is parsed, hence a side-effect import at the top of both entries.
//
// `customError` is the English floor for parses that carry no per-request error
// map: shared schemas name their message through `params.i18nKey` instead of a
// literal, so without this they would surface Zod's "Invalid input".
z.config({ jitless: true, customError: createZodErrorMap(englishValidationT) });
